module.exports = __webpack_public_path__ + "img/22-fog.34c00a06.svg";